import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6" }
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-[16px] text-[#323232] text-left" }, "Restrição de trocas", -1)
const _hoisted_4 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-[16px] text-[#323232] text-left" }, "Prazo para solicitar troca", -1)
const _hoisted_7 = { class: "text-[14px] text-[#808080] text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Exemplo:", -1)
const _hoisted_9 = { class: "flex items-center gap-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px] text-[#323232] whitespace-nowrap" }, "Solicitar trocas até", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Antecedência "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Quando "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Evento "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)
const _hoisted_14 = { class: "flex flex-col gap-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-[16px] text-[#323232] text-left" }, "Prazo de expiração do convite", -1)
const _hoisted_16 = { class: "text-[14px] text-[#808080] text-left" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Exemplo:", -1)
const _hoisted_18 = { class: "flex items-center gap-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px] text-[#323232] whitespace-nowrap" }, "Convites expiram", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Antecedência "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Quando "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Evento "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)
const _hoisted_23 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-[16px] text-[#323232] text-left" }, "Jornada (regra desta escala)", -1)
const _hoisted_25 = { class: "text-[14px] text-[#808080] text-left" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Exemplo:", -1)
const _hoisted_27 = { class: "flex items-center gap-4 mt-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px] text-[#323232] whitespace-nowrap" }, "Um médico pode ficar no máximo", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Máximo de horas consecutivas "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Pausa mínima para retornar "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#DA1E28]" }, "*")
], -1)

import { computed } from 'vue'
import SelectableCard from '@/components/designSystem/Cards/SelectableCard.vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import {
  LEAD_TIME_OPTIONS,
  REQUEST_LEAD_TIME_OPTIONS,
  CONSECUTIVE_HOURS_OPTIONS,
  WHEN_OPTIONS,
  EVENT_OPTIONS,
  TEAM_HANDOVER_VALIDATION_RULES,
  TEAM_CONSECUTIVE_HOURS_VALIDATION_RULES,
  applyHandoverRestrictionMode,
  applyConsecutiveHoursToggle,
  buildHandoverExampleText,
  buildConsecutiveHoursExampleText,
  type TeamHandoverConfig,
  type HandoverRestrictionMode
} from '@/constants/handover.constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'TeamExchangeConfigBlock',
  props: {
    config: {},
    errors: {},
    onClearError: { type: Function },
    testidPrefix: {}
  },
  setup(__props: any) {

const props = __props;



const { flags } = useFeatureFlags()

function handleSelectRestriction(mode: HandoverRestrictionMode) {
  applyHandoverRestrictionMode(props.config, mode)
  if (mode === 'disabled') {
    Object.keys(TEAM_HANDOVER_VALIDATION_RULES).forEach((field) => props.onClearError(field))
  }
}

// A seção de jornada é independente da restrição de trocas: só o próprio toggle a governa.
function handleToggleConsecutiveHours(value: boolean) {
  applyConsecutiveHoursToggle(props.config, value)
  if (!value) {
    Object.keys(TEAM_CONSECUTIVE_HOURS_VALIDATION_RULES).forEach((field) =>
      props.onClearError(field)
    )
  }
}

const consecutiveHoursExample = computed(() =>
  buildConsecutiveHoursExampleText(
    props.config.limitConsecutiveHours,
    props.config.maxConsecutiveHours,
    props.config.minRestHours,
    props.config.consecutiveHoursOurTeamOnly
  )
)

const exchangeDeadlineExample = computed(
  () =>
    buildHandoverExampleText(
      props.config.handoverRequestHours,
      props.config.handoverRequestTiming,
      props.config.handoverRequestReference
    ) || ' Solicitar trocas até 4 horas depois do fim do plantão'
)

const inviteExpirationExample = computed(
  () =>
    buildHandoverExampleText(
      props.config.handoverExpirationHours,
      props.config.handoverExpirationTiming,
      props.config.handoverExpirationReference
    ) || ' Convites expiram 48 horas antes do início do plantão'
)

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SelectableCard, {
          "data-testid": `${_ctx.testidPrefix}-restriction-disabled`,
          title: "Desabilitar trocas pelo aplicativo",
          description: "Os médicos escalados nessa escala não poderão trocar seus plantões através do aplicativo.",
          selected: !_ctx.config.allowDoctorStationHandover,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSelectRestriction('disabled')))
        }, null, 8, ["data-testid", "selected"]),
        _createVNode(SelectableCard, {
          "data-testid": `${_ctx.testidPrefix}-restriction-admin-only`,
          title: "Apenas trocas aprovadas pelo painel web",
          description: "Os médicos escalados poderão trocar seus plantões, porém apenas com autorização através do painel administrativo.",
          selected: _ctx.config.allowDoctorStationHandover && _ctx.config.requiresAdminApproval,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (handleSelectRestriction('admin_only')))
        }, null, 8, ["data-testid", "selected"]),
        _createVNode(SelectableCard, {
          "data-testid": `${_ctx.testidPrefix}-restriction-enabled`,
          title: "Habilitar trocas pelo aplicativo",
          description: "Médicos poderão trocar seus plantões com outros médicos através do aplicativo mobile sem a necessidade de aprovação de terceiros.",
          selected: _ctx.config.allowDoctorStationHandover && !_ctx.config.requiresAdminApproval,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSelectRestriction('enabled')))
        }, null, 8, ["data-testid", "selected"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("p", _hoisted_7, [
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(exchangeDeadlineExample.value), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_v_autocomplete, {
          modelValue: _ctx.config.handoverRequestHours,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.config.handoverRequestHours) = $event)),
            _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClearError('handoverRequestHours')))
          ],
          "data-testid": `${_ctx.testidPrefix}-request-hours`,
          items: _unref(REQUEST_LEAD_TIME_OPTIONS),
          "item-title": "title",
          "item-value": "value",
          variant: "outlined",
          color: "primary20",
          density: "compact",
          "hide-details": "auto",
          disabled: !_ctx.config.allowDoctorStationHandover,
          error: !!_ctx.errors.handoverRequestHours,
          "error-messages": _ctx.errors.handoverRequestHours
        }, {
          label: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"]),
        _createVNode(_component_v_autocomplete, {
          modelValue: _ctx.config.handoverRequestTiming,
          "onUpdate:modelValue": [
            _cache[5] || (_cache[5] = ($event: any) => ((_ctx.config.handoverRequestTiming) = $event)),
            _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClearError('handoverRequestTiming')))
          ],
          "data-testid": `${_ctx.testidPrefix}-request-timing`,
          items: _unref(WHEN_OPTIONS),
          "item-title": "title",
          "item-value": "value",
          variant: "outlined",
          color: "primary20",
          density: "compact",
          "hide-details": "auto",
          disabled: !_ctx.config.allowDoctorStationHandover,
          error: !!_ctx.errors.handoverRequestTiming,
          "error-messages": _ctx.errors.handoverRequestTiming
        }, {
          label: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"]),
        _createVNode(_component_v_autocomplete, {
          modelValue: _ctx.config.handoverRequestReference,
          "onUpdate:modelValue": [
            _cache[7] || (_cache[7] = ($event: any) => ((_ctx.config.handoverRequestReference) = $event)),
            _cache[8] || (_cache[8] = ($event: any) => (_ctx.onClearError('handoverRequestReference')))
          ],
          "data-testid": `${_ctx.testidPrefix}-request-reference`,
          items: _unref(EVENT_OPTIONS),
          "item-title": "title",
          "item-value": "value",
          variant: "outlined",
          color: "primary20",
          density: "compact",
          "hide-details": "auto",
          disabled: !_ctx.config.allowDoctorStationHandover,
          error: !!_ctx.errors.handoverRequestReference,
          "error-messages": _ctx.errors.handoverRequestReference
        }, {
          label: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("p", _hoisted_16, [
        _hoisted_17,
        _createTextVNode(" " + _toDisplayString(inviteExpirationExample.value), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(_component_v_autocomplete, {
          modelValue: _ctx.config.handoverExpirationHours,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.config.handoverExpirationHours) = $event)),
            _cache[10] || (_cache[10] = ($event: any) => (_ctx.onClearError('handoverExpirationHours')))
          ],
          "data-testid": `${_ctx.testidPrefix}-expiration-hours`,
          items: _unref(LEAD_TIME_OPTIONS),
          "item-title": "title",
          "item-value": "value",
          variant: "outlined",
          color: "primary20",
          density: "compact",
          "hide-details": "auto",
          disabled: !_ctx.config.allowDoctorStationHandover,
          error: !!_ctx.errors.handoverExpirationHours,
          "error-messages": _ctx.errors.handoverExpirationHours
        }, {
          label: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"]),
        _createVNode(_component_v_autocomplete, {
          modelValue: _ctx.config.handoverExpirationTiming,
          "onUpdate:modelValue": [
            _cache[11] || (_cache[11] = ($event: any) => ((_ctx.config.handoverExpirationTiming) = $event)),
            _cache[12] || (_cache[12] = ($event: any) => (_ctx.onClearError('handoverExpirationTiming')))
          ],
          "data-testid": `${_ctx.testidPrefix}-expiration-timing`,
          items: _unref(WHEN_OPTIONS),
          "item-title": "title",
          "item-value": "value",
          variant: "outlined",
          color: "primary20",
          density: "compact",
          "hide-details": "auto",
          disabled: !_ctx.config.allowDoctorStationHandover,
          error: !!_ctx.errors.handoverExpirationTiming,
          "error-messages": _ctx.errors.handoverExpirationTiming
        }, {
          label: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"]),
        _createVNode(_component_v_autocomplete, {
          modelValue: _ctx.config.handoverExpirationReference,
          "onUpdate:modelValue": [
            _cache[13] || (_cache[13] = ($event: any) => ((_ctx.config.handoverExpirationReference) = $event)),
            _cache[14] || (_cache[14] = ($event: any) => (_ctx.onClearError('handoverExpirationReference')))
          ],
          "data-testid": `${_ctx.testidPrefix}-expiration-reference`,
          items: _unref(EVENT_OPTIONS),
          "item-title": "title",
          "item-value": "value",
          variant: "outlined",
          color: "primary20",
          density: "compact",
          "hide-details": "auto",
          disabled: !_ctx.config.allowDoctorStationHandover,
          error: !!_ctx.errors.handoverExpirationReference,
          "error-messages": _ctx.errors.handoverExpirationReference
        }, {
          label: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"])
      ])
    ]),
    (_unref(flags).enabledConsecutiveHoursLimit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("p", _hoisted_25, [
            _hoisted_26,
            _createTextVNode(" " + _toDisplayString(consecutiveHoursExample.value), 1)
          ]),
          _createVNode(DsSwitch, {
            "model-value": _ctx.config.limitConsecutiveHours,
            label: "Limitar horas consecutivas nesta escala",
            "data-testid": `${_ctx.testidPrefix}-limit-consecutive-hours-switch`,
            "onUpdate:modelValue": handleToggleConsecutiveHours
          }, null, 8, ["model-value", "data-testid"]),
          _createVNode(DsSwitch, {
            modelValue: _ctx.config.consecutiveHoursOurTeamOnly,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.config.consecutiveHoursOurTeamOnly) = $event)),
            label: "Contabilizar apenas plantões como equipe interna",
            disabled: !_ctx.config.limitConsecutiveHours,
            "data-testid": `${_ctx.testidPrefix}-consecutive-hours-our-team-only-switch`
          }, null, 8, ["modelValue", "disabled", "data-testid"]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createVNode(_component_v_autocomplete, {
              modelValue: _ctx.config.maxConsecutiveHours,
              "onUpdate:modelValue": [
                _cache[16] || (_cache[16] = ($event: any) => ((_ctx.config.maxConsecutiveHours) = $event)),
                _cache[17] || (_cache[17] = ($event: any) => (_ctx.onClearError('maxConsecutiveHours')))
              ],
              "data-testid": `${_ctx.testidPrefix}-max-consecutive-hours`,
              items: _unref(CONSECUTIVE_HOURS_OPTIONS),
              "item-title": "title",
              "item-value": "value",
              variant: "outlined",
              color: "primary20",
              density: "compact",
              "hide-details": "auto",
              disabled: !_ctx.config.limitConsecutiveHours,
              error: !!_ctx.errors.maxConsecutiveHours,
              "error-messages": _ctx.errors.maxConsecutiveHours
            }, {
              label: _withCtx(() => [
                _hoisted_29
              ]),
              _: 1
            }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"]),
            _createVNode(_component_v_autocomplete, {
              modelValue: _ctx.config.minRestHours,
              "onUpdate:modelValue": [
                _cache[18] || (_cache[18] = ($event: any) => ((_ctx.config.minRestHours) = $event)),
                _cache[19] || (_cache[19] = ($event: any) => (_ctx.onClearError('minRestHours')))
              ],
              "data-testid": `${_ctx.testidPrefix}-min-rest-hours`,
              items: _unref(CONSECUTIVE_HOURS_OPTIONS),
              "item-title": "title",
              "item-value": "value",
              variant: "outlined",
              color: "primary20",
              density: "compact",
              "hide-details": "auto",
              disabled: !_ctx.config.limitConsecutiveHours,
              error: !!_ctx.errors.minRestHours,
              "error-messages": _ctx.errors.minRestHours
            }, {
              label: _withCtx(() => [
                _hoisted_30
              ]),
              _: 1
            }, 8, ["modelValue", "data-testid", "items", "disabled", "error", "error-messages"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})